import PropTypes from 'prop-types';
import React from 'react';
import GoogleMapReact from 'google-map-react';
import MarkerBlip from './MarkerBlip';

class HotelMap extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      counter:0,
    }
  }
  componentWillMount(){
    let count = 0
    this.props.hotels.forEach((hotel) =>{
      if(hotel.selected==true){
        count = count+1
      };
    });
    this.setState({
      counter:count,
    })
  }
  render() {
    const SelectHotelFromMap = (hotelId)=>{
      this.props.selectHotel(this.props.eventId,hotelId,(response)=>{
        if(hotelId.selected==true){
          let count = this.state.counter+1;
          this.setState({
              counter:count
          })
        } else{
          let count = this.state.counter-1;
          this.setState({
            counter:count
          })
        }
    });
    }
    const centerXY = {
      lat: this.props.place.position.coordinates[1],
      lng: this.props.place.position.coordinates[0],
    };
    return (
      <div style={{ height: 800, width: 'auto' }}>
      <p>Selected Hotels<span className="badge" style={{'backgroundColor':'green'}}>{this.state.counter}</span></p>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyC_dfJjkQ_rwR1TLJ1ZKWUZcttrzDypBJ0' }}
          defaultZoom={14}
          center={centerXY}
        >
          <MarkerBlip
            place={this.props.place}
            lat={this.props.place.position.coordinates[1]}
            lng={this.props.place.position.coordinates[0]}
          />
          {this.props.hotels && this.props.hotels.map(hotel =>
            <MarkerBlip
              key={hotel.id}
              hotel={hotel.id}
              selected = {hotel.selected}
              groupId={this.props.groupId}
              SelectHotelFromMap={SelectHotelFromMap}
              griddleKey={hotel.id}
              lat={hotel.position.coordinates[1]}
              lng={hotel.position.coordinates[0]}
              {...hotel}
            />
          )}
        </GoogleMapReact>
      </div>
    );
  }
}

HotelMap.propTypes = {
  hotels: PropTypes.arrayOf(PropTypes.object).isRequired,
  eventId: PropTypes.number.isRequired,
  selectHotel: PropTypes.func.isRequired,
  favoriteHotel: PropTypes.func.isRequired,
};

HotelMap.defaultProps = {
  hotels: [],
};
export default HotelMap;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelMap.js